import appConfig from '../config/app.json';

export interface AppConfig {
  version: string;
  name: string;
  description: string;
  company: {
    name: string;
    website: string;
    copyright: string;
    developer: string;
  };
  theme: {
    primaryColor: string;
    accentColor: string;
  };
}

export const config: AppConfig = appConfig;